export class CourseShippingForm {

    private $root:JQuery;
    private prototype:string;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.prototype = this.$root.data('prototype');
        if (undefined !== this.prototype) {
            this.bindUI();
        }
    }

    private bindUI() {
        this.$root.closest('.form-group').find('.js-delivery-zone__add')
            .off('click')
            .on({ click: this.addShippingZone });
        this.$root.find('.js-delivery-zone__remove')
            .off('click')
            .on({ click: this.removeShippingZone });

    }

    private getSelectedZones = () => {
        let output:any[] = [];
        this.$root.find('.js-delivery-zone__select-region').each((index:number, element:HTMLElement) => <any>output.push($(element).val()));
        return output;
    }

    private addShippingZone = () => {
        let pointer = parseInt(this.$root.data('count')) + 1;
        let $zone = $(this.prototype.toString().replace(/__name__/gi, pointer.toString()))
        let selected = this.getSelectedZones();
        if (0 < selected.length) {
            selected.forEach((item) => $zone.find('.js-delivery-zone__select-region option[value="' + item + '"]').remove());
        }
        this.$root.data('count', pointer);
        this.$root.append($zone);
        this.bindUI();
    }

    private removeShippingZone = (ev:MouseEvent) => {
        $(ev.currentTarget).closest('.js-delivery-charges__item').remove()
    }
}